module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("ij3xX"))).then(() => parcelRequire('8aqAR'));